<!-- Mobile drawer scrim — reuses the existing mobileCollapsed flag, no new state -->
<div class="sidebar-scrim" [class.sidebar-scrim--visible]="!mobileCollapsed" (click)="mobileCollapsed = true"
  aria-hidden="true"></div>

<!-- Sidebar -->
<aside class="sidebar" [class.sidebar--open]="!mobileCollapsed" [class.sidebar--collapsed]="sidebarState.collapsed">
  <div class="sidebar-head">
    <a routerLink="/dashboard">
      <img [src]="logoUrl" alt="Product Logo" class="logo">
    </a>
  </div>

  <nav class="sidebar-nav">
    <!-- Dashboard -->
    <a class="nav-item" routerLink="/dashboard" routerLinkActive="nav-item--active"
      [ngClass]="{'nav-item--active': activeTab === 'dashboard'}">
      <span class="nav-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="7" rx="1.5"></rect>
          <rect x="14" y="3" width="7" height="7" rx="1.5"></rect>
          <rect x="3" y="14" width="7" height="7" rx="1.5"></rect>
          <rect x="14" y="14" width="7" height="7" rx="1.5"></rect>
        </svg>
      </span>
      <span class="nav-label">Dashboard</span>
    </a>

    <!-- Clients submenu -->
    <div class="nav-dropdown" [class.open]="isOpen['clients']" [class.nav-dropdown--active]="router.url.startsWith('/user') ||
      router.url.startsWith('/client-directory') ||
      router.url.startsWith('/client-offer') ||
      router.url.startsWith('/coupon-code') ||
      router.url.startsWith('/whatsapp-messages')">
      <button class="nav-item has-children" type="button" (click)="toggleSubmenu($event, 'clients')"
        (keydown.enter)="toggleSubmenu($event, 'clients')" (keydown.space)="toggleSubmenu($event, 'clients')"
        [attr.aria-expanded]="isOpen['clients']" aria-haspopup="true">
        <span class="nav-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </span>
        <span class="nav-label">Clients</span>
        <svg class="down-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      <ul class="submenu" *ngIf="isOpen['clients']">
        <li><a class="dropdown-item" routerLink="/user" routerLinkActive="active">Client</a></li>
        <li><a class="dropdown-item" routerLink="/client-directory" routerLinkActive="active">Client Directory</a>
        </li>
        <li><a class="dropdown-item" routerLink="/client-offer" routerLinkActive="active">Client Offers</a></li>
        <li><a class="dropdown-item" routerLink="/coupon-code" routerLinkActive="active">Coupons</a></li>
        <li><a class="dropdown-item" routerLink="/whatsapp-messages" routerLinkActive="active">WhatsApp Campaign</a>
        </li>
      </ul>
    </div>

    <!-- Transactions -->
    <a class="nav-item" routerLink="/transaction" routerLinkActive="nav-item--active"
      [ngClass]="{'nav-item--active': activeTab === 'transaction'}">
      <span class="nav-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <rect x="1" y="4" width="22" height="16" rx="2"></rect>
          <line x1="1" y1="10" x2="23" y2="10"></line>
        </svg>
      </span>
      <span class="nav-label">Transactions</span>
    </a>

    <!-- Maintenance -->
    <a class="nav-item" routerLink="/maintenance" routerLinkActive="nav-item--active"
      [ngClass]="{'nav-item--active': activeTab === 'maintenance'}">
      <span class="nav-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
        </svg>
      </span>
      <span class="nav-label">Maintenance</span>
    </a>

    <!-- Logs submenu -->
    <div class="nav-dropdown" [class.open]="isOpen['logs']" [class.nav-dropdown--active]="router.url.startsWith('/log-in-log') ||
      router.url.startsWith('/error-log')">
      <button class="nav-item has-children" (click)="toggleSubmenu($event, 'logs')"
        (keydown.enter)="toggleSubmenu($event, 'logs')" [attr.aria-expanded]="isOpen['logs']">
        <span class="nav-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
          </svg>
        </span>
        <span class="nav-label">Logs</span>
        <svg class="down-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>

      <ul class="submenu" *ngIf="isOpen['logs']">
        <li><a class="dropdown-item" routerLink="/log-in-log" routerLinkActive="active">Login Logs</a></li>
        <li><a class="dropdown-item" routerLink="/error-log" routerLinkActive="active">Error Logs</a></li>
      </ul>
    </div>

    <!-- Reports -->
    <a class="nav-item" routerLink="/reports" routerLinkActive="nav-item--active"
      [ngClass]="{'nav-item--active': activeTab === 'reports'}">
      <span class="nav-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="20" x2="18" y2="10"></line>
          <line x1="12" y1="20" x2="12" y2="4"></line>
          <line x1="6" y1="20" x2="6" y2="14"></line>
        </svg>
      </span>
      <span class="nav-label">Reports</span>
    </a>

    <!-- Support Tickets -->
    <a class="nav-item" routerLink="/tickets" routerLinkActive="nav-item--active"
      [ngClass]="{'nav-item--active': activeTab === 'tickets'}">
      <span class="nav-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 12a9 9 0 0 1 18 0"></path>
          <path d="M21 12v5a2 2 0 0 1-2 2h-1"></path>
          <rect x="17" y="12" width="4" height="6" rx="1.5"></rect>
          <rect x="3" y="12" width="4" height="6" rx="1.5"></rect>
        </svg>
      </span>
      <span class="nav-label">Support Tickets</span>
    </a>
  </nav>

  <div class="sidebar-version">
    <span class="sv-name">{{ productLabel }}</span>
    <span class="sv-ver">v{{ appVersion }}</span>
  </div>

  <div class="sidebar-copyright">
    <a href="https://www.plusphysio.com/contact" target="_blank">Copyright</a>
    <span>&copy; {{ today | date:'yyyy' }}</span>
    <a href="https://www.ifourtechnolab.com/" target="_blank">ifourtechnolab.com</a>
  </div>
</aside>

<!-- Topbar -->
<header class="topbar">
  <button class="topbar-toggle" type="button" (click)="toggleSidebar()"
    aria-controls="sidebarNav" aria-label="Toggle navigation">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  </button>

  <div class="topbar-spacer"></div>

  <div class="itemlastr">
    <div class="dropdown-container">
      <button class="topbar-profile" type="button" (click)="isDropdownOpen = !isDropdownOpen"
        aria-haspopup="true" [attr.aria-expanded]="isDropdownOpen">
        <span class="avatar-chip">{{ userInitials }}</span>
        <span class="profile-name">{{ username?.FirstName }} {{ username?.LastName }}</span>
        <span class="profile-caret">▾</span>
      </button>

      <ul class="dropdown-menu dropdown-menu-end" *ngIf="isDropdownOpen">
        <li><a class="dropdown-item" routerLink="/setting">Settings</a></li>
        <li><a class="dropdown-item logout-item" (click)="onLogout()">Logout</a></li>
      </ul>
    </div>
  </div>
</header>
